import React from "react";
function Loading(){
    return(
        <>
             <span className="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>{" "}Loading...
        </>
    )
}
export default Loading